
// Gestion des transitions entre les pages via BarbaJs
// Documentation : http://barbajs.org

var promise  = null;
var elCliked = null;

(function($){

	if( !pageAjax )
		return false;

/*
########   ##     ##  ##    ##    ######    ########   ####   #######   ##    ##   
##         ##     ##  ###   ##   ##    ##      ##       ##   ##     ##  ###   ##   
##         ##     ##  ####  ##   ##            ##       ##   ##     ##  ####  ##   
######     ##     ##  ## ## ##   ##            ##       ##   ##     ##  ## ## ##   
##         ##     ##  ##  ####   ##            ##       ##   ##     ##  ##  ####   
##         ##     ##  ##   ###   ##    ##      ##       ##   ##     ##  ##   ###   
##          #######   ##    ##    ######       ##      ####   #######   ##    ##   
*/
	/*
	 * Liste des fonctions à excécuter uniquement sur le template de la home
	 */
	var tid = null;
    var Homepage = Barba.BaseView.extend({
		namespace: 'single-accueil',
		onEnter: function() {
		  // The new Container is ready and attached to the DOM.
		},
		onEnterCompleted: function() {

		  // The Transition has just finished
			$('.home-slider').imagesLoaded({ background: true })
			.always( function( instance ) {

				nbSlideHome = $('.home-slide').length;
				cptSlide = 0;

				tid = setTimeout(sliderAutoPlay, 4000);
				function sliderAutoPlay() {
					cptSlide++;
					changeSlide();
					tid = setTimeout(sliderAutoPlay, 4000);
				}
				function abortTimer() {
					clearTimeout(tid);
				}

				function changeSlide(){

					$('.home-slider--init').removeClass('home-slider--init');

					if( cptSlide < 0 ) cptSlide = nbSlideHome-1;
					if( cptSlide >= nbSlideHome ) cptSlide = 0;

					$('.home-slider-title li.is-active').removeClass('is-active');
					$('.home-slider-title li:eq('+ cptSlide +')').addClass('is-active');

					$('.home-slide.home-slide--active').removeClass('home-slide--active');
					$('.home-slide:eq('+ cptSlide +')').addClass('home-slide--active');

					$('.home-slider-nav').addClass('is-animated');
					setTimeout(function(){
						$('.home-slider-nav').removeClass('is-animated');
					}, 1000);
				}

				$('.home-slider-nav li').on('click', function(){
					abortTimer();
					cptSlide = ( $(this).hasClass('prev-slide') ) ? cptSlide - 1 : cptSlide + 1;
					changeSlide();
				});
			});

			$('.home-category-content').on('mouseenter', function(){
				$('.home-category-image').removeClass('home-category-image--is-visible');
				$('.home-category-image[data-index="'+ $(this).data('index') +'"]').addClass('home-category-image--is-visible');

				if( $(window).width() >= 992 ){
					$(this).find('.home-category-content-toggle').slideDown();
				}
			}).on('mouseleave', function(){
				if( $(window).width() >= 992 ){
					$(this).find('.home-category-content-toggle').slideUp();
				}
			});
		},
		onLeave: function() {
		  // A new Transition toward a new page has just started.
		},
		onLeaveCompleted: function() {
		  // The Container has just been removed from the DOM.
			clearTimeout(tid);
		}
	});
	
	/*
	 * Liste des fonctions à excécuter uniquement sur le template archive
	 */
	var Archivepage = Barba.BaseView.extend({
		namespace: 'archive-project',
		onEnter: function() {
		  // The new Container is ready and attached to the DOM.
		  	$('.grid').imagesLoaded({ background: true })
			.always( function( instance ) {
				function getHashFilter() {
					var hash = location.hash;
					var matches = location.hash.match( /filter=([^&]+)/i );
					var hashFilter = matches && matches[1];
					return hashFilter && decodeURIComponent( hashFilter );
				}

				var $grid = $('.grid');
				var $filters = $('.filter-button-group').on( 'click', '.filter', function() {
					var filterAttr = $( this ).attr('data-filter');
					// set filter in hash
					location.hash = 'filter=' + encodeURIComponent( filterAttr );
				});
				var isIsotopeInit = false;

				function onHashchange() {
					var hashFilter = getHashFilter();
					if ( !hashFilter && isIsotopeInit ) {
						return;
					}
					isIsotopeInit = true;
					// filter isotope
					$grid.isotope({
						itemSelector: '.grid-sizer',
						masonry: {
							columnWidth: '.grid-sizer',
							gutter: '.gutter-sizer',
						},
						percentPosition: true,
						filter: hashFilter
					});
					// set selected class on button
					if ( hashFilter ) {
						$filters.find('.current').removeClass('current');
						$filters.find('[data-filter="' + hashFilter + '"]').addClass('current');
					}
				}

				$(window).on( 'hashchange', onHashchange );
				// trigger event handler to init Isotope
				onHashchange();
					// var filterValue = $(this).attr('data-filter');
					// $('.filter-button-group li').removeClass('current');
					// $(this).addClass('current');
					// $grid.isotope({ filter: filterValue });
				// });
			});
		},
		onEnterCompleted: function() {
		  	// The Transition has just finished
		},
		onLeave: function() {
		  	// A new Transition toward a new page has just started.
		},
		onLeaveCompleted: function() {
		  // The Container has just been removed from the DOM.
		}
	});
	
	/*
	 * Liste des fonctions à excécuter uniquement sur le template détail projet
	 */
	var Singlepage = Barba.BaseView.extend({
		namespace: 'single-project',
		onEnterCompleted: function(){
			$('.grid').imagesLoaded({ background: true })
			.always( function( instance ) {
				$('.grid').masonry({
					// options
					columnWidth: '.grid-sizer',
					itemSelector: '.grid-sizer',
					gutter: '.gutter-sizer',
					percentPosition: true
				});
			});
			setTimeout(function(){
				$('.single-project-header-info').addClass('single-project-header-info--visible');
			}, 800);
		}
	});

/*
########   ########      ###     ##    ##    ######    ####  ########   ####   #######   ##    ##   
   ##      ##     ##    ## ##    ###   ##   ##    ##    ##      ##       ##   ##     ##  ###   ##   
   ##      ##     ##   ##   ##   ####  ##   ##          ##      ##       ##   ##     ##  ####  ##   
   ##      ########   ##     ##  ## ## ##    ######     ##      ##       ##   ##     ##  ## ## ##   
   ##      ##   ##    #########  ##  ####         ##    ##      ##       ##   ##     ##  ##  ####   
   ##      ##    ##   ##     ##  ##   ###   ##    ##    ##      ##       ##   ##     ##  ##   ###   
   ##      ##     ##  ##     ##  ##    ##    ######    ####     ##      ####   #######   ##    ##   
*/

	// Définition de la transition de base entre les pages
	var BaseTransition = Barba.BaseTransition.extend({
		start: function() {
			// On supprime cette classe afin de réinitialiser les effets de parallax
			$("body").addClass('is-loading');
			$('body').removeClass('ctrlParallax');
			promise = this;
			if( !pageTransition ){
				// Ajout d'un délai avant de charger le nouveau contenu pour permettre l'affichage correct de la transition
				// Délai à ajuster suivant le temps de transition
				setTimeout(function(){
					promise.newContainerLoading.then(promise.finish.bind(promise));
				 }, 800);
			}else{
				showLoader();
			}
		},
		finish: function() {
			this.done();
		},
		showloader: function() {
			this.done();
		}
	});

	// Transition de la page d'archive projets vers un détail de projet
	var ProjectToSingleProjetTransition = Barba.BaseTransition.extend({
		start: function() {
			var promise = this;
			// elCliked.closest('.project-teaser').find('.project-teaser-animation').css('position','fixed');
			parent  = elCliked.closest('.project-teaser');
			parent.find('.project-teaser-header').addClass('project-teaser-header--hide');
			img     = parent.find('img');
			imgPos  = img.offset();
			element = $('<div class="project-teaser-animation"></div>');
			element.appendTo('.page-container');
			element.css({
				'position':              'fixed',
				'z-index':               5,
				'background':            'transparent center center no-repeat',
				'background-image':      "url('" + img.attr('src') + "')",
				'background-size':       'cover',
				'width':  img.width(),
				'height': img.height(),
				'top':    imgPos.top - $(document).scrollTop(),
				'left':   imgPos.left - $(document).scrollLeft()
			});
			tl = new TimelineLite();
			tl.pause();
			tl.add([
				TweenMax.to( element, .5, 
				{ 
					top:    0,
					left:   0,
					width:  "100%",
					height: "100vh",
					delay:  0.10
				})
			]);
			tl.call(function() {
				promise.newContainerLoading.then(promise.finish.bind(promise));
			});
			tl.play();
		},
		finish: function() {
			$('html, body').scrollTop(0);
			this.done();
			newElement = $('.single-project-header');
			tl = new TimelineLite();
			tl.pause();
			tl.add([
				TweenMax.to( element, .5, 
				{ 
					top:    newElement.offset().top,
					left:   newElement.offset().left,
					width:  newElement.width(),
					height: newElement.height(),
					delay:  0.10
				})
			]);
			tl.call(function() {
				element.remove();
			});
			tl.play();
			
		}
	});

	// Transition de page détail projet vers une autre page détail projet
	var SingletProjectToSingleProjectTransition = Barba.BaseTransition.extend({
		start: function() {
			var promise = this;
			parent  = elCliked;
			// parent.find('.project-teaser-header').addClass('project-teaser-header--hide');
			img     = parent.find('img');
			imgPos  = img.offset();
			element = $('<div class="project-teaser-animation"></div>');
			element.appendTo('.page-container');
			element.css({
				'position':              'fixed',
				'z-index':               5,
				'background':            'transparent center center no-repeat',
				'background-image':      "url('" + img.data('src') + "')",
				'background-size':       'cover',
				'width':  img.width(),
				'height': img.height(),
				'top':    imgPos.top - $(document).scrollTop(),
				'left':   imgPos.left - $(document).scrollLeft()
			});
			tl = new TimelineLite();
			tl.pause();
			tl.add([
				TweenMax.to( element, .5, 
				{ 
					top:    0,
					left:   0,
					width:  "100%",
					height: "100vh",
					delay:  0.10
				})
			]);
			tl.call(function() {
				promise.newContainerLoading.then(promise.finish.bind(promise));
			});
			tl.play();
		},
		finish: function() {
			$('html, body').scrollTop(0);
			this.done();
			newElement = $('.single-project-header');
			tl = new TimelineLite();
			tl.pause();
			tl.add([
				TweenMax.to( element, .5, 
				{ 
					top:    newElement.offset().top,
					left:   newElement.offset().left,
					width:  newElement.width(),
					height: newElement.height(),
					delay:  0.10
				})
			]);
			tl.call(function() {
				element.remove();
			});
			tl.play();
			
		}
	});

	Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

	Barba.Pjax.preventCheck = function(evt, element) {

		if (!Barba.Pjax.originalPreventCheck(evt, element)) {
			return false;
		}

		if( $(element).closest("#wpadminbar").length > 0){
			if( evt.type == "click" ){
				linkHandler( $(element) );
			}
			return false;
		}

		return true;
	};

	// Exécution de la transition de base entre les pages
	// On pourra ici définir différentes transitions suivant la page actuelle et la page demandée
	// PARTIE À APPROFONDIR, ENCORE UN PEU FLOU...
	Barba.Pjax.getTransition = function() {
		var newPage = window.location.pathname;
        var prevPage = Barba.HistoryManager.prevStatus().namespace;
        var tab      = newPage.split('/');

        // console.log("from "+prevPage+" to "+newPage);

        if( prevPage == "archive-project" && tab[1] == "projet" ){
		    return ProjectToSingleProjetTransition;
        }

        if( prevPage == "single-project" && tab[1] == "projet" && tab[2] != "" ){
		    return SingletProjectToSingleProjectTransition;
        }

		return BaseTransition;
	};

	// Recharge la fonction pageInit à la fin de chaque transition
	Barba.Dispatcher.on('transitionCompleted', function(currentStatus, oldStatus) {
		if ( pageTransition ) {
			$('body').imagesLoaded( { background: true })
			.always( function(instance) {
				pageInit();
				hideLoader();
			});
		}else{
			$('body').imagesLoaded( { background: true })
			.always( function(instance) {
				pageInit();
				$("body").removeClass('is-loading');
			});
		}
	});

	// Fonction excécutée à chaque nouveau contenu injecté dans le DOM
	Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus) {
		$('html, body').animate({ scrollTop: 0 }, 0);
	});

	Barba.Dispatcher.on('linkClicked', function(el, e) {
        elCliked = $(el);
    });

	/* 
	 * Initialisation des fonctions spécifiques pour la home page
	 * À décommenter si précédemment défini
	 */
	Homepage.init();
	Archivepage.init();
	Singlepage.init();


	// Initialisation de Barba
	Barba.Pjax.start();

	/*
	 * Fonction permettant des précharger les pages au survol des liens
	 * Un peu gourmand si beaucoup de liens survolés
	 * À décommenter si besoin
	 */
	// Barba.Prefetch.init();

})(jQuery);
